import React, { useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion, useReducedMotion } from "framer-motion";

import StoreIOS from "../../stuff/apple.png";
import StoreGoogle from "../../stuff/android.png";

import card from "../../stuff/toast.png";
import card1 from "../../stuff/card1.png";
import card2 from "../../stuff/card2.png";
import card3 from "../../stuff/card3.png";
import card4 from "../../stuff/card4.png";
import card5 from "../../stuff/card5.png";

const PRIMARY = "#0c513f";
const ACCENT = "#ffbf07";
const CREAM = "#fdf7e9";

function Section5() {
  const reduceMotion = useReducedMotion();

  // ✅ Put your real store links here:
  const IOS_URL = "https://apps.apple.com/ng/app/school-chow/id6744178351";
  const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.endee.schoolchow";

  const cards = useMemo(() => [card, card1, card2, card3, card4, card5], []);
  // duplicate for seamless loop
  const marqueeCards = useMemo(() => [...cards, ...cards, ...cards], [cards]);

  const duration = reduceMotion ? 0 : 22;

  return (
    <section
      className="shop_section"
      id="download"
      style={{
        position: "relative",
        overflow: "hidden",
        padding: "76px 0",
        background: `linear-gradient(180deg, ${CREAM}, #ffffff)`,
        borderTop: "1px solid rgba(255,191,7,0.22)",
      }}
    >
      {/* soft background blobs */}
      <div aria-hidden="true" style={{ position: "absolute", inset: 0 }}>
        <div
          style={{
            position: "absolute",
            top: "-180px",
            left: "-220px",
            width: 560,
            height: 560,
            borderRadius: 999,
            background: "rgba(255,191,7,0.18)",
            filter: "blur(80px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-220px",
            right: "-260px",
            width: 620,
            height: 620,
            borderRadius: 999,
            background: "rgba(12,81,63,0.10)",
            filter: "blur(90px)",
          }}
        />
      </div>

      <Container style={{ position: "relative", zIndex: 2 }}>
        <Row className="align-items-center justify-content-center g-5">
          {/* Left: Marquee */}
          <Col lg={6} className="d-flex justify-content-center">
            <div
              style={{
                width: "100%",
                maxWidth: 560,
                position: "relative",
                borderRadius: 26,
                padding: 14,
                background: "rgba(255,255,255,0.70)",
                border: "1px solid rgba(255,191,7,0.28)",
                boxShadow: "0 22px 70px rgba(0,0,0,0.10)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                overflow: "hidden",
              }}
            >
              {/* top accent bar */}
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 6,
                  background: `linear-gradient(90deg, ${ACCENT}, rgba(255,191,7,0.15), ${ACCENT})`,
                  opacity: 0.9,
                }}
              />

              {/* fade edges so marquee feels premium */}
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  width: 90,
                  background: "linear-gradient(90deg, rgba(253,247,233,1), rgba(253,247,233,0))",
                  zIndex: 3,
                }}
              />
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: 0,
                  width: 90,
                  background: "linear-gradient(270deg, rgba(253,247,233,1), rgba(253,247,233,0))",
                  zIndex: 3,
                }}
              />

              {/* sheen sweep */}
              {!reduceMotion && (
                <motion.div
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    top: "-70%",
                    left: "-45%",
                    width: "40%",
                    height: "240%",
                    background: "rgba(255,255,255,0.28)",
                    transform: "rotate(18deg)",
                    filter: "blur(2px)",
                    zIndex: 2,
                  }}
                  animate={{ x: ["-10%", "240%"] }}
                  transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                />
              )}

              {/* marquee track */}
              <div style={{ overflow: "hidden" }}>
                <motion.div
                  style={{ display: "flex", alignItems: "center", gap: 18, padding: "18px 10px" }}
                  animate={reduceMotion ? undefined : { x: ["0%", "-33.333%"] }}
                  transition={reduceMotion ? undefined : { duration, ease: "linear", repeat: Infinity }}
                >
                  {marqueeCards.map((imgSrc, index) => (
                    <motion.div
                      key={index}
                      whileHover={{ y: -4, scale: 1.02 }}
                      transition={{ duration: 0.25 }}
                      style={{
                        flex: "0 0 auto",
                        borderRadius: 18,
                        padding: 10,
                        background: "rgba(255,255,255,0.85)",
                        border: "1px solid rgba(12,81,63,0.10)",
                        boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
                      }}
                    >
                      <img
                        src={imgSrc}
                        alt={`preview-${index}`}
                        style={{ width: 150, height: "auto", display: "block" }}
                      />
                    </motion.div>
                  ))}
                </motion.div>
              </div>

              {/* little caption */}
              <div style={{ textAlign: "center", marginTop: 6, color: "rgba(16,16,16,0.58)" }}>
                <span style={{ fontSize: 13 }}>
                  A quick peek at the experience ✨
                </span>
              </div>
            </div>
          </Col>

          {/* Right: Download */}
          <Col lg={6} className="text-center text-lg-start">
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              viewport={{ once: true }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                padding: "10px 14px",
                borderRadius: 999,
                background: "rgba(12,81,63,0.06)",
                border: "1px solid rgba(12,81,63,0.10)",
                marginBottom: 14,
              }}
            >
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: 999,
                  background: ACCENT,
                  boxShadow: "0 0 18px rgba(255,191,7,0.6)",
                }}
              />
              <span style={{ color: PRIMARY, fontWeight: 800, letterSpacing: "0.2px", fontSize: 13 }}>
                Download & start ordering
              </span>
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut", delay: 0.05 }}
              viewport={{ once: true }}
              style={{
                fontSize: "clamp(32px, 3.6vw, 46px)",
                lineHeight: 1.05,
                letterSpacing: "-0.4px",
                marginBottom: 10,
                color: "#101010",
              }}
            >
              Chow for less.
              <span style={{ color: PRIMARY }}> Feel the difference.</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
              viewport={{ once: true }}
              style={{
                maxWidth: 560,
                margin: "0 auto 18px",
                fontSize: 15.5,
                lineHeight: 1.8,
                color: "rgba(16,16,16,0.62)",
                fontFamily: "Kadwa",
              }}
            >
              Enjoy your favourite meals at pocket-friendly prices with a service charge so tiny
              you’ll hardly notice. Tap below and let’s get you fed.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
              viewport={{ once: true }}
              style={{
                display: "flex",
                justifyContent: "center",
                
                gap: 14,
                flexWrap: "wrap",
              }}
            >
              {/* ✅ iOS => App Store */}
              <motion.a
                href={IOS_URL}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.04, y: -2 }}
                whileTap={{ scale: 0.98 }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 16,
                  padding: 10,
                  background: "rgba(255,255,255,0.85)",
                  border: "1px solid rgba(255,191,7,0.30)",
                  boxShadow: "0 16px 40px rgba(0,0,0,0.10)",
                  textDecoration: "none",
                }}
              >
                <img src={StoreIOS} alt="Download on the App Store" style={{ height: 52, width: "auto" }} />
              </motion.a>

              {/* ✅ Android => Play Store */}
              <motion.a
                href={ANDROID_URL}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.04, y: -2 }}
                whileTap={{ scale: 0.98 }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 16,
                  padding: 10,
                  background: "rgba(255,255,255,0.85)",
                  border: "1px solid rgba(255,191,7,0.30)",
                  boxShadow: "0 16px 40px rgba(0,0,0,0.10)",
                  textDecoration: "none",
                }}
              >
                <img src={StoreGoogle} alt="Get it on Google Play" style={{ height: 52, width: "auto" }} />
              </motion.a>
            </motion.div>

            {/* tiny trust note */}

          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Section5;
